import React from 'react'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Row } from './Badges.styles'
import { Badge } from '@dsny/dsny-component-library'

export default function Badges({ release, style }) {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Row style={style}>
      {release?.trending && (
        <Badge
          style={{
            background: theme.colors.alert20,
            color: theme.colors.alert70,
            textTransform: 'uppercase',
            marginRight: 6
          }}
          label={t('home.trending')}
          mode="dark"
          type="tonal"
        />
      )}

      {release?.release_type && (
        <Badge
          style={{ textTransform: 'uppercase' }}
          label={t(
            `options.RELEASE-TYPE-${release?.release_type.toUpperCase()}`
          )}
          mode="dark"
          type="tonal"
        />
      )}
    </Row>
  )
}
